import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonLabel, IonToggle } from '@ionic/angular';
import { LetDirective } from '@ngrx/component';

import { AttachmentParentType, LinkedItem, NtyUniversalCreateComponent } from '@ninety/mobile/platform/api';
import {
  AttachmentsComponent,
  DescriptionComponent,
  NtyFormErrorComponent,
  TeamMultiSelectComponent,
  TitleComponent,
  UserSingleSelectComponent,
} from '@ninety/mobile/platform/components';

import { CreateHeadlineStore } from './create-headline.store';

@Component({
  selector: 'nty-create-headline',
  templateUrl: './create-headline.component.html',
  styleUrls: ['./create-headline.component.scss'],
  providers: [CreateHeadlineStore],
  imports: [
    IonLabel,
    IonToggle,
    LetDirective,
    FormsModule,
    ReactiveFormsModule,
    DescriptionComponent,
    TeamMultiSelectComponent,
    TitleComponent,
    UserSingleSelectComponent,
    AttachmentsComponent,
    NtyFormErrorComponent,
  ],
})
export class CreateHeadlineComponent implements NtyUniversalCreateComponent, OnInit, OnDestroy {
  readonly store = inject(CreateHeadlineStore);

  readonly attachmentType = AttachmentParentType.Headline;

  @ViewChild('attachments') attachments?: AttachmentsComponent;

  ngOnInit(): void {
    this.store.init();
  }

  ngOnDestroy(): void {
    this.store.destroy();
  }

  create(linkedItem?: LinkedItem): void {
    this.store.createHeadline(linkedItem, this.attachments);
  }

  protected isOptional(formControl: AbstractControl): boolean {
    return !formControl.hasValidator(Validators.required) && !formControl.disabled;
  }

  protected hasRequiredError(controlName: string): boolean {
    return this.store.form.get(controlName)?.hasError('required') || false;
  }
}
